import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import jwtDecode from 'jwt-decode';
import { Logger } from 'utils/Logger';
import { onLoginSuccess } from 'reducers/auth/sagas';

import { network, signupNetwork } from './types';
import {
  requestNetworkSuccess,
  requestNetworkFailure,
  requestSignupNetworkSuccess,
  requestSignupNetworkFailure,
} from './actions';

const logger = new Logger('Saga:SignupNetwork');

export function* requestNetworkSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.networkGet', {
        slug: action.network,
      }),
    );

    yield put(requestNetworkSuccess(response.data));
  } catch (error) {
    logger.error('Failed to get network:', error);
    yield put(requestNetworkFailure(error));
  }
}

export function* requestSignupNetworkSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');
  const { network: networkSlug, ...values } = action.payload;

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.platform.networkSignup', { slug: networkSlug }),
      values,
    );

    const token = yield call(jwtDecode, response.data.jwtToken);

    yield call(
      onLoginSuccess,
      {
        accessToken: response.data.jwtToken,
        expiresAt: token.exp,
        tokenPayload: token,
      },
      true,
    );
    yield put(requestSignupNetworkSuccess());
  } catch (error) {
    logger.error('Failed to signup from network:', error);
    yield put(requestSignupNetworkFailure(error.response));
  }
}

export default function* marketplaceSaga() {
  return yield all([
    takeLatest(network.request, requestNetworkSaga),
    takeLatest(signupNetwork.request, requestSignupNetworkSaga),
  ]);
}
